// extracted by mini-css-extract-plugin
export default {"container":"FinishPage_container__MsWKB","img":"FinishPage_img__xhl4E","title":"FinishPage_title__RL7pq","txt":"FinishPage_txt__0piWU"};